import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

export default function QrLink() {
  const { id, btnId } = useParams(); // Get the optional client ID from the route
  const decodedId = id ? decodeURIComponent(id) : null; // Decode the parameter
  const isSaved = useRef(false); // Ref to track if the link has been saved

  useEffect(() => {
    if (decodedId && !isSaved.current) {
      window.location.href = decodedId; // Redirect to the decoded URL
      saveQrLink(decodedId); // Save the QR link
      isSaved.current = true; // Mark as saved
    }
  }, [decodedId]);

  const saveQrLink = async decodedId => {
    try {
      await axios.post('/api/qr-scan-count', {
        qr_url: decodedId,
        btnId: btnId,
      });
    } catch (error) {
      console.error('Failed to save media data:', error);
    }
  };

  return <></>;
}
